<!--<curr-loader [diameter]="40" [isLoading]="!isEditorReady" *ngIf="!isEditorReady"></curr-loader>-->

<!--<div class="editor-container" [class.visible-editor]="isEditorReady" [id]="editorId">-->
<!--  <editor [apiKey]="key" [init]="editorOptions" [(ngModel)]="valueForTinyEditor" (onInit)="onEditorInitialized()"-->
<!--          (onClick)="updateValue()" (onFocusOut)="focusOut()" (onChange)="updateValue()"></editor>-->
<!--</div>-->

<div class="editor-block" *ngIf="showTopSection">
  <div class="editor-header">
    <div class="editor-title">{{ title }}</div>
    <mat-slide-toggle
      color="primary"
      [(ngModel)]="isEditorMode"
      (ngModelChange)="onToggleMode($event)">
      <span class="editor-toggle">{{ subtitle }}</span>
    </mat-slide-toggle>
  </div>
  <div class="editor-hint">{{ hint }}</div>
</div>

<curr-loader [diameter]="40" [isLoading]="!isEditorReady && isEditorMode" *ngIf="isEditorMode"></curr-loader>

<!-- Editor mode -->
<div class="editor-container" [class.visible-editor]="isEditorReady" *ngIf="isEditorMode">
  <editor
    [apiKey]="key"
    [init]="editorOptions"
    [(ngModel)]="valueForTinyEditor"
    (onInit)="onEditorInitialized()"
    (onKeyUp)="onKeyPress($event)"
    (onChange)="onEditorChange($event)"
    (onBlur)="onBlur($event)">
  </editor>
</div>

<!-- Read mode -->
<div *ngIf="!isEditorMode && hasValue" [currMath]="readModeValue" class="editor-read-mode"></div>
